import { render, staticRenderFns } from "./PlantDetailList.vue?vue&type=template&id=ff45daf0&scoped=true"
import script from "./PlantDetailList.vue?vue&type=script&lang=ts"
export * from "./PlantDetailList.vue?vue&type=script&lang=ts"
import style0 from "./PlantDetailList.vue?vue&type=style&index=0&id=ff45daf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff45daf0",
  null
  
)

export default component.exports